import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

const container = document.getElementById("root");

// Static prerender (scripts/prerender.js, jsdom-based) prerenders per-route
// HTML; hydrate it if present, otherwise render.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app, {
    // Prerendered markup can trigger a benign, self-recovering
    // hydration reconciliation on the sticky header even though the resulting
    // DOM is byte-identical (verified). Swallow ONLY those recoverable
    // hydration notices; surface every other recoverable error normally.
    onRecoverableError: (error) => {
      const msg = (error && error.message) || "";
      const hydration = /(#418|#423|#425|#310|#421|Hydration|hydrat)/i.test(msg);
      if (!hydration) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  });
} else {
  ReactDOM.createRoot(container).render(app);
}
